import { NgModule } from '@angular/core';
import { UiUxInputNumberProviderDirective } from './ui-ux-input-number-provider.directive';

// Global directive — selector is 'cwc-input-number'.
// Applies to ALL <cwc-input-number> elements app-wide.
@NgModule({
  declarations: [UiUxInputNumberProviderDirective],
  exports: [UiUxInputNumberProviderDirective],
})
export class UiUxInputNumberProviderDirectiveModule {}
